import { BPContainer } from "@/components/bp/bpcontainer";
import * as React from "react";
import { Container, Header, HeaderSubheader, Segment } from "@/components/bp/bp-ui";

export function BPSection(props: {
    header?: string; subHeader?: string, children: any;
    scrolling?: boolean,
    simple?: boolean
}) {
    const scrollingStyle = props.scrolling ? { style: { 'maxHeight': '50vh', 'overflowY': 'auto' } } : {}

    return <>
        {props.header && <Header attached={'top'} as="h3">{props.header}
            {props.subHeader &&
                <HeaderSubheader>
                    {props.subHeader}
                </HeaderSubheader>
            }
        </Header>}
        {props.simple
            ? <BPContainer {...scrollingStyle}>
                {props.children}
            </BPContainer>
            : <Segment attached {...scrollingStyle}>
                {props.children}
            </Segment>}
    </>;
}
